/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

import React, {useEffect} from 'react';

const ScrollTopOnMount = () => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);
};

export default ScrollTopOnMount